import { Component, model, input } from '@angular/core';
import { DisplayLayout } from '@shared/types/dev';
import { TooltipOptions } from 'primeng/api';

@Component({
  selector: 'idel-layout-toggler',
  templateUrl: './layout-toggler.component.html',
  styleUrl: './layout-toggler.component.scss',
})
export class LayoutTogglerComponent {
  public readonly layout = model.required<DisplayLayout>();
  public readonly leftValueTooltip = input<string>('Vue côte à côte');
  public readonly rightValueTooltip = input<string>('Vue liste');
  public readonly tooltipPosition = input<TooltipOptions['tooltipPosition']>('right');
}
